import { researchIcons, type ResearchIconName } from "@/lib/icons/research-icons";

const ICON_LABELS: Record<ResearchIconName, string> = {
  sun: "Солнце",
  moon: "Луна",
  monitor: "Монитор",
  smartphone: "Смартфон",
  alertCircle: "Ошибка",
  alertTriangle: "Внимание",
  arrowLeft: "Стрелка влево",
  arrowRight: "Стрелка вправо",
  barChart: "График",
  check: "Галочка",
  checkCircle: "Успех",
  circle: "Круг",
  copy: "Копировать",
  xCircle: "Отмена",
  download: "Скачать",
  fileText: "Документ",
  folder: "Папка",
  folderOpen: "Открытая папка",
  gift: "Подарок",
  home: "Дом",
  gitCompare: "Сравнение",
  link: "Ссылка",
  menu: "Меню",
  panelLeft: "Панель слева",
  panelRight: "Панель справа",
  pencil: "Редактировать",
  plus: "Добавить",
  radar: "Радар",
  receipt: "Чек",
  redo: "Повторить",
  refresh: "Обновить",
  search: "Поиск",
  trash: "Удалить",
  trendingUp: "Рост",
  undo: "Отменить",
  shieldAlert: "Риск",
  shieldCheck: "Защита",
  creditCard: "Оплата",
  layoutDashboard: "Дашборд",
  settings: "Настройки",
  logOut: "Выход",
  chevronDown: "Вниз",
  chevronRight: "Вперёд",
  ticketPercent: "Скидка",
  users: "Люди",
  building: "Компания",
  key: "Ключ",
  layers: "Слои",
  database: "Данные",
  close: "Закрыть",
  messageCircleQuestion: "Вопрос",
  zap: "Молния",
  clock: "Время",
  briefcase: "Кейсы",
  imagePlus: "Картинка",
  history: "История",
  pause: "Пауза",
  locate: "Геолокация",
  mapPin: "Метка на карте",
  phone: "Телефон",
  mail: "Почта",
  minus: "Минус",
  upload: "Загрузка",
  bold: "Жирный",
  italic: "Курсив",
  underline: "Подчёркивание",
  strikethrough: "Зачёркивание",
  alignLeft: "По левому краю",
  alignCenter: "По центру",
  alignRight: "По правому краю",
};

export type LandingIconOption = {
  value: ResearchIconName;
  label: string;
  searchText: string;
};

function iconSearchText(value: ResearchIconName, label: string): string {
  const spaced = value.replace(/([A-Z])/g, " $1").toLowerCase();
  return `${value} ${label} ${spaced}`.toLowerCase();
}

export const LANDING_ICON_OPTIONS: LandingIconOption[] = (
  Object.keys(researchIcons) as ResearchIconName[]
).map((value) => {
  const label = ICON_LABELS[value];
  return {
    value,
    label,
    searchText: iconSearchText(value, label),
  };
});

export function getLandingIconLabel(value: ResearchIconName): string {
  return ICON_LABELS[value] ?? value;
}

export function filterLandingIconOptions(query: string): LandingIconOption[] {
  const q = query.trim().toLowerCase();
  if (!q) return LANDING_ICON_OPTIONS;
  return LANDING_ICON_OPTIONS.filter((opt) => opt.searchText.includes(q));
}

export function parseLandingIcon(value: unknown): ResearchIconName {
  if (typeof value === "string" && value in researchIcons) {
    return value as ResearchIconName;
  }
  return "fileText";
}
